import { COMMON } from "../../util/localizations"

const TRANSLATIONS = {
    en: {
        addNode: COMMON.en.addNode,
        addAndConnect: 'Add a Node and Connect to , "{0}"',
        add: COMMON.en.add,
        cancel: COMMON.en.cancel,
        instructions: "This creates a new blank node. You'll be able to add more details and connect this node to others after it has been added to the board."
    }
}

export default TRANSLATIONS